// Eingangsanimation START 

// vco-custom.js
document.addEventListener('DOMContentLoaded', function() {
  
  // Prüft echte Sichtbarkeit (auch in overflow:hidden)
  function isElementVisibleInViewport(element) {
    const rect = element.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    
    if (rect.bottom < 0 || rect.top > viewportHeight || 
        rect.right < 0 || rect.left > viewportWidth) {
      return false;
    }
    
    // Check overflow:hidden parents
    let parent = element.parentElement;
    while (parent && parent !== document.body) {
      const parentStyle = getComputedStyle(parent);
      const parentRect = parent.getBoundingClientRect();
      
      if (parentStyle.overflow === 'hidden' || 
          parentStyle.overflowX === 'hidden' || 
          parentStyle.overflowY === 'hidden') {
        
        if (rect.bottom < parentRect.top || rect.top > parentRect.bottom ||
            rect.right < parentRect.left || rect.left > parentRect.right) {
          return false;
        }
      }
      parent = parent.parentElement;
    }
    
    return true;
  }

  const animatedElements = document.querySelectorAll('.vco-e-animation');  
  if (animatedElements.length === 0) return;

  const alreadyAnimated = new Set();

  function animateElement(element) {
    if (alreadyAnimated.has(element)) return;    
    element.classList.add('vco-in-view');
    alreadyAnimated.add(element);
  }

  // Animate initially visible elements
  animatedElements.forEach(element => {
    if (isElementVisibleInViewport(element)) {
      animateElement(element);
    }
  });

  // IntersectionObserver for scroll animations
  const observerOptions = {
    root: null,
    rootMargin: '10px',
    threshold: [0, 0.1]
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting && isElementVisibleInViewport(entry.target)) {
        animateElement(entry.target);
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  animatedElements.forEach(element => {
    if (!alreadyAnimated.has(element)) {
      observer.observe(element);
    }
  });

  // Scroll fallback for overflow:hidden (throttled)
  let scrollTimeout;
  function handleScroll() {
    if (scrollTimeout) return;    
    scrollTimeout = setTimeout(() => {
      animatedElements.forEach(element => {
        if (!alreadyAnimated.has(element) && isElementVisibleInViewport(element)) {
          animateElement(element);
        }
      });
      scrollTimeout = null;
    }, 100);
  }

  window.addEventListener('scroll', handleScroll, { passive: true });
  
  // Add scroll listeners to scrollable containers
  document.querySelectorAll('*').forEach(el => {
    const style = getComputedStyle(el);
    if (style.overflowY === 'auto' || style.overflowY === 'scroll' ||
        style.overflowX === 'auto' || style.overflowX === 'scroll') {
      el.addEventListener('scroll', handleScroll, { passive: true });
    }
  });

  // Resize handler
  let resizeTimeout;
  window.addEventListener('resize', () => {
    if (resizeTimeout) clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      animatedElements.forEach(element => {
        if (!alreadyAnimated.has(element) && isElementVisibleInViewport(element)) {
          animateElement(element);
        }
      });
    }, 250);
  }, { passive: true });

  // Fallback for old browsers
  if (!window.IntersectionObserver) {
    setTimeout(() => {
      animatedElements.forEach(animateElement);
    }, 1000);
  }

  // Debug mode
  if (window.location.search.includes('debug=true')) {
    console.log(`VCO Animations: ${animatedElements.length} elements found`);    
    const debugStyle = document.createElement('style');
    debugStyle.textContent = `
      .vco-e-animation:not(.vco-in-view) { outline: 2px dashed red !important; }
      .vco-e-animation.vco-in-view { outline: 2px solid green !important; }
    `;
    document.head.appendChild(debugStyle);
  }
});

// Eingangsanimation END 